import React from 'react';

class Grid extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("grid-row", null, /*#__PURE__*/React.createElement("grid-columns", {
      class: "default-12"
    }, this.props.children));
  }

}

export default Grid;